
import { ProfileEffects } from "./profile/profile.effects";
import { QuickRegisterEffects } from './quick-register/quick-register.effects';

export const coreEffectsAtBootstrap = [ProfileEffects, QuickRegisterEffects];
